export enum DefaultAccentColor {
    default = '#99338A',
    light = '#F27021',
    dark = '#F27021',
}
